import { copyProjectsToAccount } from '@/api/v4/copy-project.api';
import { useMutation } from '@tanstack/react-query';

export const useCopyProjectsToAccount = () => {
  return useMutation({
    mutationFn: copyProjectsToAccount,
  });
};
